export default {"src":"/_next/static/media/no-fillers.94665604.svg","height":71,"width":69,"blurWidth":0,"blurHeight":0};